import { render, staticRenderFns } from "./IconEllipse.vue?vue&type=template&id=f45995f0&"
import script from "./IconEllipse.vue?vue&type=script&lang=js&"
export * from "./IconEllipse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f45995f0')) {
      api.createRecord('f45995f0', component.options)
    } else {
      api.reload('f45995f0', component.options)
    }
    module.hot.accept("./IconEllipse.vue?vue&type=template&id=f45995f0&", function () {
      api.rerender('f45995f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconEllipse.vue"
export default component.exports